import { useState, useEffect, useCallback } from "react"
import { getUserInfo, updateUserInfo as updateStoredUserInfo } from "../handlers/authHandlers"

/**
 * Custom hook para manejar la autenticación y el token
 * @returns {Object} Objeto con el token y funciones relacionadas con la autenticación
 */
export const useAuth = () => {
    const [token, setToken] = useState(null)
    const [userInfo, setUserInfo] = useState(null)

    // Cargar información del usuario al iniciar
    useEffect(() => {
        const storedUserInfo = getUserInfo()
        if (storedUserInfo) {
            setUserInfo(storedUserInfo)
            setToken(storedUserInfo.token)
        }
    }, [])

    // Actualizar información del usuario
    const updateUserInfo = useCallback(
        (newUserData) => {
            if (!userInfo) return

            const success = updateStoredUserInfo(userInfo, newUserData)
            if (success) {
                setUserInfo((prevInfo) => ({ ...prevInfo, ...newUserData }))
            }
        },
        [userInfo],
    )

    return {
        token,
        userInfo,
        updateUserInfo,
        isAuthenticated: !!token,
    }
}

